import { BatteryDistribution } from "@/components/VirtualBattery/types/percentages";
import {
  Box,
  ListItem,
  Paper,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface BatterySelectorItemParams {
  batteryDistribution: BatteryDistribution;
  selected: boolean;
  onClick: (batteryDistribution: BatteryDistribution) => void;
}

export const BatterySelectorItem: FC<BatterySelectorItemParams> = ({
  batteryDistribution,
  selected,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
    <Paper
      style={{ width: "100%", height: "100%", overflow: "hidden" }}
      variant="outlined"
      elevation={2}
    >
      <ListItem
        button
        onClick={() => onClick?.(batteryDistribution)}
        selected={selected}
        style={{ cursor: selected ? "" : "pointer" }}
      >
        <Box sx={{ width: "100%" }}>
          <Box style={{ display: "flex" }}>
            <Typography variant="subtitle2">
              {t("common:text.solar_wallet.move.label")}:
            </Typography>
            <Typography variant="body2">
              {batteryDistribution["batteryName"]}
            </Typography>
          </Box>
          <Box style={{ display: "flex" }}>
            <Typography variant="subtitle2">{t("common:text.contracts_title")}: </Typography>
            <Typography variant="body2">
              {batteryDistribution["distribution"].map((distribution, i) => {
                const content = `${distribution["contractName"]}(${distribution["pesPercentage"]}%)`
                return (i === batteryDistribution["distribution"].length-1) ?  `${content} ` : `${content}, `;
              })}
            </Typography>
          </Box>
        </Box>
      </ListItem>
    </Paper>
  );
};

export default BatterySelectorItem;
